module.exports = __webpack_public_path__ + "img/pvc_650g_b1_farbauswahl_weiss_schwarz_lichtgrau_hellgrau_blau.af261315.jpg";